import { useEffect, useCallback } from 'react'
import { RetirementConstraintsResponse } from '@Types'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import { useIraConstraints } from './useIraConstraints'

export interface IraConstraintsByMethodResponse {
  constraintData?: RetirementConstraintsResponse
  constraintError: boolean
  constraintLoading: boolean
}

export const useIraConstraintsByMethod = (
  account: string,
  method: string,
  direction: string
): IraConstraintsByMethodResponse => {
  const getBaseUrl = () => `${getAppConfigSetting('apiUrl')}${SENTINEL_API}`
  const url = `${getBaseUrl()}/ira_constraints/${account}/${method}/${direction}`

  const { handleChange, constraintData, constraintError, constraintLoading } = useIraConstraints(url)
  const handleChangeMemo = useCallback(handleChange, [])

  useEffect(() => {
    if (account && method && direction) {
      handleChangeMemo()
    }
  }, [account, method, direction, handleChangeMemo])

  return { constraintData, constraintError, constraintLoading }
}
